export default {
  'strongly_disagree': 1,
  'disagree': 2,
  'neither': 3,
  'agree': 4,
  'strongly_agree': 5
}
